module.exports = __webpack_public_path__ + "static/media/03-MGM_Casino_Fish_Restaurant.2b5b10b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mgm-casino/03-MGM_Casino_Fish_Restaurant.jpg
// module id = 1188
// module chunks = 37